import { createAction, props } from '@ngrx/store';
import { BoardUsersListExportData, BoardUsersListImportData, BoardUsersListsRespData } from 'src/app/model/api/data-rest';
import { PaginationParams } from 'src/app/model/api/pagination-params';


export const getBoardusersLists = createAction('GET_BOARDUSERS_LISTS', props<{ paging?: PaginationParams }>());
export const getBoardusersListsSuccess = createAction('GET_BOARDUSERS_LISTS_SUCCESS', props<{ boardUsersResp: BoardUsersListsRespData }>());
export const getBoardusersListsFailed = createAction('GET_BOARDUSERS_LISTS_FAILED', props<{ errorMessage: string }>());

export const exportBoarduserList = createAction('EXPORT_BOARDUSER_LIST', props<{ name: string, version: string }>());
export const exportBoarduserListSuccess = createAction('EXPORT_BOARDUSER_LIST_SUCCESS', props<{ respData: BoardUsersListExportData; message: string }>());
export const exportBoarduserListFailed = createAction('EXPORT_BOARDUSER_LIST_FAILED', props<{ errorMessage: string }>());

export const resetBoarduserListDialog = createAction('RESET_BOARDUSER_LIST_DIALOG');
export const editBoarduserList = createAction('EDIT_BOARDUSER_LIST', props<{ name: string, version: string, listId: number, paging?: PaginationParams }>());
export const editBoarduserListSuccess = createAction('EDIT_BOARDUSER_LIST_SUCCESS', props<{
	respData: BoardUsersListExportData,
	message: string,
	paging?: PaginationParams
}>());
export const editBoarduserListFailed = createAction('EDIT_BOARDUSER_LIST_FAILED', props<{ errorMessage: string }>());

export const deleteBoarduserList = createAction('DELETE_BOARDUSER_LIST', props<{ version: string, listId: number, paging?: PaginationParams }>());
export const deleteBoarduserListSuccess = createAction('DELETE_BOARDUSER_LIST_SUCCESS', props<{
	respData: BoardUsersListExportData, message: string, paging?: PaginationParams
}>());
export const deleteBoarduserListFailed = createAction('DELETE_BOARDUSER_LIST_FAILED', props<{ errorMessage: string }>());

export const resetImportBoarduserListDialog = createAction('RESET_IMPORT_BOARDUSER_LIST_DIALOG');
export const importBoarduserList = createAction('IMPORT_BOARDUSER_LIST', props<{ listId: number, paging?: PaginationParams }>());
export const importBoarduserListSuccess = createAction('IMPORT_BOARDUSER_LIST_SUCCESS', props<{ respData: BoardUsersListImportData; message: string, paging?: PaginationParams }>());
export const importBoarduserListFailed = createAction('IMPORT_BOARDUSER_LIST_FAILED', props<{ errorMessage: string }>());
